import React, { Component } from 'react'
import { connect } from 'react-redux'
import Validator from 'simple-react-validator'
import { storeTestimonial } from '../../../redux/actions/testimonials';
import { Grid, Row, Col } from 'react-bootstrap'
import Card from '../../Card/Card';
import User from '../../../helper/User';
import { testimonialService } from '../../../services/testimonials';
import { alertActions } from '../../../redux/actions/alert-actions';

class EditTestimonialForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            author: '',
            description: '',
            company: ''
        }
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
        this.Validator = new Validator();
    }

    componentDidMount() { 
        testimonialService.showTestimonial(this.props.id).then(response => {
            console.log("response", response);
        
            this.setState({
                author: response.data.author,
                description: response.data.description,
                company: response.data.company
            })
        })
    }

    inputChangeHandler(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    submitHandler() {
        if (this.Validator.allValid()) {
            const data = { ...this.state, };
            testimonialService.editTestimonial(this.props.id, data).then(
                response => {
                    this.props.success(response.message);
                    this.props.paginationCall();
                    this.props.closeModal();
                }
            );
        } else {
            this.Validator.showMessages();
            this.forceUpdate();
        }
    }

    render() {
        return (
            <div >
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card bsClass={['innerCard']} content={
                                <React.Fragment>
                                    <div className='row' >
                                        <div className='col-md-6' >
                                            <div className='form-group'>
                                                <label>Full Name</label>
                                                <input
                                                    name='author' 
                                                    value={this.state.author} 
                                                    onChange={this.inputChangeHandler} 
                                                    className='form-control' 
                                                    type='text' 
                                                    placeholder='Full Name' />
                                                {this.Validator.message('Full Name', this.state.author, 'required')}
                                            </div>
                                        </div>
                                        <div className='col-md-6' >
                                            <div className='form-group'>
                                                <label>Tour Company Name or Group Name</label>
                                                <input 
                                                    name='company' 
                                                    value={this.state.company} 
                                                    onChange={this.inputChangeHandler} 
                                                    className='form-control' 
                                                    type='text' 
                                                    placeholder="Tour Company Name or Group Name" />
                                                {this.Validator.message('Company/Group  Name', this.state.company, 'required')}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="">Your Testimonial</label>
                                                <textarea 
                                                    value={this.state.description} 
                                                    name='description' 
                                                    onChange={this.inputChangeHandler} 
                                                    className='form-control' 
                                                    style={{minHeight: "130px"}} 
                                                    placeholder="Your Testimonial"></textarea>
                                                {this.Validator.message('Testimonial', this.state.description, 'required')}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='text-right my-20' >
                                        <button onClick={this.submitHandler} className='backButton pt-sm no_radius pb-sm primary text-xs btn btn-lg btn-info btn btn-lg btn-info  btn btn-default' >Save</button>
                                    </div>
                                </React.Fragment>
                            } />
                        </Col>
                    </Row>
                </Grid>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        storeTestimonial: (data) => { return dispatch(storeTestimonial(data)) },
        success: (message) => { return dispatch(alertActions.success(message)) },
    }
}

export default connect(null, mapDispatchToProps)(EditTestimonialForm)
